// Copied from: https://tanstack.com/query/latest/docs/framework/react/guides/advanced-ssr
// with added staleTime parameter

// Since QueryClientProvider relies on useContext under the hood, we have to put 'use client' on top
import { createLogger } from '@svenskaspelab/nova-core/nextjs/log';
import { defaultShouldDehydrateQuery, isServer, QueryClient } from '@tanstack/react-query';

const logger = createLogger('real-time-messages:day-time-limit:tanstack');

function makeQueryClient(staleTime = 60 * 1000) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime,
        gcTime: 5 * 60 * 1000,
      },
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
        shouldRedactErrors: (error) => {
          logger.warn('shouldRedactErrors error', { error });
          // We should not catch Next.js server errors
          // as that's how Next.js detects dynamic pages
          // so we cannot redact them.
          // Next.js also automatically redacts errors for us
          // with better digests.
          return false;
        },
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient(staleTime?: number) {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient(staleTime);
  }
  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient) browserQueryClient = makeQueryClient(staleTime);
  return browserQueryClient;
}
